interface CacheEntry<T> {
  value: T;
  expiration?: number | null;
}

export const StorageService = {
  setItem<T>(storage: Storage, storageItemName: string, value: T, expirationInSeconds?: number): void {
    const itemContentToBeCached = this.constructCacheItem(value, expirationInSeconds);
    const valueAsAString: string = JSON.stringify(itemContentToBeCached);
    storage.setItem(storageItemName, valueAsAString);
  },
  getItem<T>(storage: Storage, storageItemName: string): T | null {
    const cacheContent = this.retrieveCacheUsingKey<T>(storage, storageItemName);
    return cacheContent != null ? cacheContent.value : null;
  },
  constructCacheItem<T>(value: T, expirationInSeconds?: number): CacheEntry<T> {
    return expirationInSeconds != null
      ? { value: value, expiration: new Date().getTime() + expirationInSeconds * 1000 }
      : { value: value, expiration: null };
  },
  retrieveCacheUsingKey<T>(storage: Storage, storageItemName: string): CacheEntry<T> | null {
    const cachedItemContent = this.getItemInternal<CacheEntry<T>>(storage, storageItemName);
    return !cachedItemContent || this.isExpired(cachedItemContent) ? null : cachedItemContent;
  },
  isExpired<T>(entry: CacheEntry<T>): boolean {
    return !!entry.expiration && new Date().getTime() > entry.expiration;
  },
  getItemInternal<T>(storage: Storage, storageItemName: string): T | null {
    const item = storage.getItem(storageItemName);
    return item !== null ? JSON.parse(item) : null;
  }
};
